import { Navigate } from "react-router-dom";

const ExternalRoute = ({ children }) => {
  const token = localStorage.getItem("externalAccessToken");

  if (!token) {
    return <Navigate to="/external" />;
  }

  return children;
};

export default ExternalRoute;
